var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Loading", { attrs: { active: _vm.loading, "is-full-page": true } }),
      _c(
        "div",
        { staticClass: "pa-3", attrs: { align: "center", justify: "center" } },
        [
          _c(
            "v-card",
            { staticClass: "mb-3", attrs: { align: "left", justify: "left" } },
            [
              _c(
                "v-card-text",
                { staticClass: "pa-3 font-weight-light white black--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "primary--text lighten-2 pa-2" },
                    [_vm._v(" mdi-alert-octagon-outline ")]
                  ),
                  _vm._v(" Administração > Títulos Problemáticos ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "pa-3" },
            [
              _c(
                "v-card-actions",
                { staticClass: "pb-0" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        color: "primary",
                        disabled:
                          _vm.itensSelecionados.length === 0 || _vm.loading,
                        "data-cy": "btnReenviar"
                      },
                      on: { click: _vm.abrirModalReenviar }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-send")
                      ]),
                      _vm._v(
                        " Reenviar (" +
                          _vm._s(_vm.itensSelecionados.length) +
                          ") "
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        disabled:
                          _vm.itensSelecionados.length === 0 || _vm.loading,
                        "data-cy": "btnIrregularizar"
                      },
                      on: { click: _vm.abrirModalIrregularizar }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-alert")
                      ]),
                      _vm._v(
                        " Irregularizar (" +
                          _vm._s(_vm.itensSelecionados.length) +
                          ") "
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-data-table", {
                staticClass: "elevation-1 mt-3",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.titulosProblematicos,
                  loading: _vm.loading,
                  "footer-props": {
                    itemsPerPageOptions: [10, 20, 50, 100],
                    itemsPerPageText: "Itens por página:"
                  },
                  "item-key": "id_titulo",
                  "server-items-length": _vm.totalItems,
                  page: _vm.currentPage,
                  "items-per-page": _vm.itemsPerPage,
                  "show-select": ""
                },
                on: {
                  "update:page": [
                    function($event) {
                      _vm.currentPage = $event
                    },
                    _vm.carregarDados
                  ],
                  "update:itemsPerPage": function($event) {
                    _vm.itemsPerPage = $event
                  },
                  "update:items-per-page": [
                    function($event) {
                      _vm.itemsPerPage = $event
                    },
                    _vm.carregarDados
                  ]
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.data_vencimento`,
                      fn: function({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatarData(item.data_vencimento)) +
                              " "
                          )
                        ]
                      }
                    },
                    {
                      key: `item.st_envio_titulo`,
                      fn: function({ item }) {
                        return [
                          _vm._v(" " + _vm._s(item.st_envio_titulo) + " ")
                        ]
                      }
                    },
                    {
                      key: `item.st_envio_historico`,
                      fn: function({ item }) {
                        return [
                          _vm._v(" " + _vm._s(item.st_envio_historico) + " ")
                        ]
                      }
                    },
                    {
                      key: `item.erro_remessa`,
                      fn: function({ item }) {
                        return [
                          item.erro_remessa
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function({ on, attrs }) {
                                          return [
                                            _c(
                                              "span",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "text-truncate d-inline-block",
                                                    staticStyle: {
                                                      "max-width": "200px"
                                                    }
                                                  },
                                                  "span",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.erro_remessa) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(item.erro_remessa))
                                  ])
                                ]
                              )
                            : _c("span", [_vm._v("—")])
                        ]
                      }
                    }
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.itensSelecionados,
                  callback: function($$v) {
                    _vm.itensSelecionados = $$v
                  },
                  expression: "itensSelecionados"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "640" },
          model: {
            value: _vm.dialogReenviar,
            callback: function($$v) {
              _vm.dialogReenviar = $$v
            },
            expression: "dialogReenviar"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "headline primary--text" },
                [
                  _c("v-icon", { attrs: { left: "", color: "primary" } }, [
                    _vm._v("mdi-send")
                  ]),
                  _vm._v(" Confirmar Reenvio ")
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c("p", { staticClass: "text-body-1 mb-3" }, [
                    _vm._v(" Você está prestes a reenviar "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.itensSelecionados.length))
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.itensSelecionados.length === 1
                            ? "título"
                            : "títulos"
                        ) +
                        ". "
                    )
                  ]),
                  _c("v-simple-table", {
                    staticClass: "mb-3",
                    attrs: { dense: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function() {
                          return [
                            _c("thead", [
                              _c("tr", [
                                _c("th", { staticClass: "text-left" }, [
                                  _vm._v("ID Título")
                                ]),
                                _c("th", { staticClass: "text-left" }, [
                                  _vm._v("Nosso Número")
                                ]),
                                _c("th", { staticClass: "text-left" }, [
                                  _vm._v("Comarca")
                                ]),
                                _c("th", { staticClass: "text-left" }, [
                                  _vm._v("UF")
                                ]),
                                _c("th", { staticClass: "text-left" }, [
                                  _vm._v("Status")
                                ])
                              ])
                            ]),
                            _c(
                              "tbody",
                              _vm._l(_vm.itensSelecionados, function(item) {
                                return _c("tr", { key: item.id_titulo }, [
                                  _c("td", [_vm._v(_vm._s(item.id_titulo))]),
                                  _c("td", [_vm._v(_vm._s(item.nosso_numero))]),
                                  _c("td", [_vm._v(_vm._s(item.comarca))]),
                                  _c("td", [_vm._v(_vm._s(item.uf))]),
                                  _c("td", [_vm._v(_vm._s(item.status_titulo))])
                                ])
                              }),
                              0
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  }),
                  _c("p", { staticClass: "text-body-2 mb-0" }, [
                    _vm._v(" Deseja continuar com o reenvio? ")
                  ])
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey darken-1",
                        text: "",
                        disabled: _vm.loadingReenviar
                      },
                      on: {
                        click: function($event) {
                          _vm.dialogReenviar = false
                        }
                      }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        loading: _vm.loadingReenviar,
                        disabled: _vm.loadingReenviar
                      },
                      on: { click: _vm.confirmarReenvio }
                    },
                    [_vm._v(" Confirmar Reenvio ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "640" },
          model: {
            value: _vm.dialogIrregularizar,
            callback: function($$v) {
              _vm.dialogIrregularizar = $$v
            },
            expression: "dialogIrregularizar"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "headline error--text" },
                [
                  _c("v-icon", { attrs: { left: "", color: "error" } }, [
                    _vm._v("mdi-alert")
                  ]),
                  _vm._v(" Confirmar Irregularização ")
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c("p", { staticClass: "text-body-1 mb-3" }, [
                    _vm._v(" Você está prestes a irregularizar "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.itensSelecionados.length))
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.itensSelecionados.length === 1
                            ? "título"
                            : "títulos"
                        ) +
                        " com o código de irregularidade "
                    ),
                    _c("strong", [_vm._v("K1")]),
                    _vm._v(". ")
                  ]),
                  _c("v-simple-table", {
                    staticClass: "mb-3",
                    attrs: { dense: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function() {
                          return [
                            _c("thead", [
                              _c("tr", [
                                _c("th", { staticClass: "text-left" }, [
                                  _vm._v("ID Título")
                                ]),
                                _c("th", { staticClass: "text-left" }, [
                                  _vm._v("Nosso Número")
                                ]),
                                _c("th", { staticClass: "text-left" }, [
                                  _vm._v("Comarca")
                                ]),
                                _c("th", { staticClass: "text-left" }, [
                                  _vm._v("UF")
                                ]),
                                _c("th", { staticClass: "text-left" }, [
                                  _vm._v("Status")
                                ])
                              ])
                            ]),
                            _c(
                              "tbody",
                              _vm._l(_vm.itensSelecionados, function(item) {
                                return _c("tr", { key: item.id_titulo }, [
                                  _c("td", [_vm._v(_vm._s(item.id_titulo))]),
                                  _c("td", [_vm._v(_vm._s(item.nosso_numero))]),
                                  _c("td", [_vm._v(_vm._s(item.comarca))]),
                                  _c("td", [_vm._v(_vm._s(item.uf))]),
                                  _c("td", [_vm._v(_vm._s(item.status_titulo))])
                                ])
                              }),
                              0
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  }),
                  _c("p", { staticClass: "text-body-2 red--text mb-0" }, [
                    _vm._v(
                      " Esta ação não poderá ser desfeita. Deseja continuar? "
                    )
                  ])
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey darken-1",
                        text: "",
                        disabled: _vm.loadingIrregularizar
                      },
                      on: {
                        click: function($event) {
                          _vm.dialogIrregularizar = false
                        }
                      }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        loading: _vm.loadingIrregularizar,
                        disabled: _vm.loadingIrregularizar
                      },
                      on: { click: _vm.confirmarIrregularizar }
                    },
                    [_vm._v(" Confirmar Irregularização ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "420", persistent: "" },
          model: {
            value: _vm.dialogProgresso,
            callback: function($$v) {
              _vm.dialogProgresso = $$v
            },
            expression: "dialogProgresso"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(" Processando Irregularização... ")
              ]),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c("p", { staticClass: "text-body-2 mb-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.progressoProcessados) +
                        " de " +
                        _vm._s(_vm.progressoTotal) +
                        " títulos processados "
                    )
                  ]),
                  _c(
                    "v-progress-linear",
                    {
                      attrs: {
                        value: _vm.progressoPorcentagem,
                        color: "error",
                        height: "24",
                        rounded: ""
                      }
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.progressoPorcentagem) + "%")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "560" },
          model: {
            value: _vm.dialogErros,
            callback: function($$v) {
              _vm.dialogErros = $$v
            },
            expression: "dialogErros"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "headline warning--text" },
                [
                  _c("v-icon", { attrs: { left: "", color: "warning" } }, [
                    _vm._v("mdi-alert-circle")
                  ]),
                  _vm._v(" Resultado da Irregularização ")
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-3" },
                [
                  _c(
                    "p",
                    { staticClass: "text-body-1 mb-2" },
                    [
                      _c("v-icon", { attrs: { color: "success", small: "" } }, [
                        _vm._v("mdi-check-circle")
                      ]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.irregularizacaoSucessos))
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.irregularizacaoSucessos === 1
                              ? "título irregularizado"
                              : "títulos irregularizados"
                          ) +
                          " com sucesso. "
                      )
                    ],
                    1
                  ),
                  _vm.irregularizacaoErros.length > 0
                    ? _c(
                        "p",
                        { staticClass: "text-body-1 mb-3" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "error", small: "" } },
                            [_vm._v("mdi-close-circle")]
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.irregularizacaoErros.length))
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.irregularizacaoErros.length === 1
                                  ? "título falhou"
                                  : "títulos falharam"
                              ) +
                              ": "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.irregularizacaoErros.length > 0
                    ? _c("v-simple-table", {
                        attrs: { dense: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", { staticClass: "text-left" }, [
                                        _vm._v("ID Título")
                                      ]),
                                      _c("th", { staticClass: "text-left" }, [
                                        _vm._v("Nosso Número")
                                      ]),
                                      _c("th", { staticClass: "text-left" }, [
                                        _vm._v("Erro")
                                      ])
                                    ])
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.irregularizacaoErros, function(
                                      falha
                                    ) {
                                      return _c(
                                        "tr",
                                        { key: falha.id_titulo },
                                        [
                                          _c("td", [
                                            _vm._v(_vm._s(falha.id_titulo))
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(falha.nosso_numero))
                                          ]),
                                          _c(
                                            "td",
                                            { staticClass: "error--text" },
                                            [_vm._v(_vm._s(falha.erro))]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3489054763
                        )
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogErros = false
                        }
                      }
                    },
                    [_vm._v(" Fechar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: {
            color: _vm.snackbarColor,
            timeout: "5000",
            top: "",
            right: ""
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { text: "" },
                        on: {
                          click: function($event) {
                            _vm.snackbar = false
                          }
                        }
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Fechar ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [_vm._v(" " + _vm._s(_vm.snackbarMessage) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }